// translations/pages/idd/ja.js

export const iddPageJA = {
  "kicker": "レガシーソフトウェアのモダナイゼーション",
  "title": "長年育ってきたソフトウェアを、その知識を失わずに最新の技術へ移行する",
  "lead": "多くの企業では、長年かけて育ってきたアプリケーションが業務の重要な部分を支えています。VBAを用いたExcel、Accessデータベース、あるいは古い.NET、Delphi、Rのプログラムなどです。そこでは価格や精算、重要指標が計算され、他のどこにも書かれていない業務ルールや例外処理がコードの中に眠っています。私たちはこうしたアプリケーションをIDD（Intent-Driven Development）主導かつ [Veridion](veridion) による自動化で最新技術へと移行し、新しいシステムが旧システムと同一の結果を出すことを実証します。",
  "migration": [
    {
      "title": "これまでモダナイゼーションが失敗してきた理由",
      "paragraphs": [
        "アプリケーションはもはやほとんど保守できず、技術は古く、自動テストはなく、ドキュメントには抜けがあります。ルールを書いた人がすでに社内にいないことも少なくありません。そのため、費用がいくらかかるのか、新しいシステムが最終的に同じ計算をするのかを誰も言えず、再開発は年々先送りされています。"
      ]
    },
    {
      "title": "AIが変えること",
      "paragraphs": [
        "[Veridion](veridion) とIntent-Driven Development（IDD）により、私たちのAI社員は長年蓄積されたコードベースを短時間で読み解き、アーキテクチャと依存関係を再構築し、目標・意思決定・テストシナリオをIDDプロジェクトメモリに記録したうえで、アプリケーションを自動で再構築し新旧システムを比較します。これによりモダナイゼーションは経済的に成立します。単なる機械的コード変換ではありません。ループ内の人間（Human-in-the-Loop）がIDDを通じてアーキテクチャの意思決定、業務評価、承認、そしてプロジェクトの責任を担います。"
      ]
    },
    {
      "title": "知識は残り、技術は刷新される",
      "paragraphs": [
        "ビジネスルール、特殊ケース、業務知識、過去の決定、そして誰も書き留めてこなかった要件は、すべて新しいシステムに引き継がれます。その拠り所となるのは既存のコードだけです。あらゆるルールとあらゆる計算は、その根拠となる旧コードの箇所とともに記録されます。コードが明らかにしていない点は、お客様とともに明確にします。新しくなるのは、技術、アーキテクチャ、保守性、テスト容易性、運用、そしてユーザーインターフェースです。"
      ]
    },
    {
      "title": "まず代表的な一部、それから判断",
      "paragraphs": [
        "最初にあるのは紙の上の全体構想ではなく、お客様と一緒に選ぶアプリケーションの代表的な一部です。当社は既存システムを分析し、目標アーキテクチャを設計し、この部分を新しい技術で動作する形に実装して旧システムと比較します。その後お客様は、進め方と目標アーキテクチャが有効かどうか、実際の難しさがどこにあるか、どのようなリスクがあるか、移行全体に現実的にどれだけの工数がかかるかを把握し、それを基に判断されます。"
      ]
    },
    {
      "title": "同じ結果を、小数点以下まで正確に",
      "paragraphs": [
        "新しいシステムを構築する前に、旧システムに実データと意図的に選んだ入力で計算させ、その結果をリファレンス、いわゆるゴールデンマスター（Golden Master）として記録します。新しいシステムには同じ入力を与え、バックツーバックテストですべての出力をこのリファレンスと比較します。精度はお客様が決めます。1セント単位、小数点以下10桁、あるいはビット単位までです。すべての差異は説明され修正されるか、旧システムの誤りを修正することをお客様が明示的に決定します。"
      ]
    }
  ],
  "request": {
    "title": "お客様のアプリケーション",
    "text": "どのアプリケーションをモダナイズしたいのか、何で開発されているのか、どのような結果を出しているのかをお知らせください。",
    "cta": "移行について問い合わせる",
    "subject": "レガシーソフトウェアのモダナイゼーション"
  },
  "method": {
    "title": "追跡可能なAI開発",
    "paragraphs": [
      "AIエージェントは短時間でコードを書きます。コンテキストが欠けていると、もっともらしい推測でそれを補い、そうした推測は運用に入って初めて表に出ることが少なくありません。そのため当社では、どのエージェントも単一のプロンプトだけで作業することはありません。目標、決定事項、そしてシステムが合格しなければならないシナリオは、コードを書く前に確定しています。未確定の点があればエージェントは質問し、あらゆる変更は決定に遡って追跡できます。",
      "当社はこうして自社製品を開発し、あらゆる移行プロジェクトでも同じように取り組んでいます。その背後にある手法がIntent-Driven Developmentです。"
    ]
  }
};
